


























import DictMixin from '@/mixins/dict-mixin';
import { mixins } from 'vue-class-component';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
@Component({
  components: {}
})
export default class EWall extends mixins(DictMixin) {
  @Prop() groups!: any;

  created() {
    this.onVisibleChange();
  }

  keys: string[] = [];
  @Watch('groups')
  async onVisibleChange() {
    // this.keys = Object.keys(this.groups);
  }
}
